module.exports = __webpack_public_path__ + "img/cancel.efe8cc14.svg";